import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Amplify } from 'aws-amplify';
import AppRoutes from './routes/Routes';
import { awsConfig } from './aws-config/aws-config';
import { setConfigLoadFailed } from './store/slices/config/configSlice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import IconIndicator from './components/user-feedback/IconIndicator';
import { globals } from './common/globals';
import { fetchConfig } from './store/slices/config/configThunks';
import { selectConfigExpressSettings } from './store/slices/config/configSelectors';
import MaintainancePage from './pages/Maintenance';
import useDocumentTitle from './hooks/useDocumentTitle';

// eslint-disable-next-line no-undef
window.awsConfig = awsConfig[process.env.REACT_APP_ENVIRONMENT];
// eslint-disable-next-line no-undef
Amplify.configure(awsConfig[process.env.REACT_APP_ENVIRONMENT]);

const App = () => {
  const dispatch = useDispatch();
  globals.dispatch = dispatch;

  const location = useLocation();

  const [lastPlace, setLastPlace] = useState('');
  const [loadingConfig, setLoadingConfig] = useState(true);

  const settings = useSelector(selectConfigExpressSettings);

  useDocumentTitle();

  useEffect(() => {
    const loadConfig = async () => {
      setLoadingConfig(true);
      await dispatch(setConfigLoadFailed(false));

      const cityIdentiferPath = location.pathname.split('/')[1];
      if (cityIdentiferPath !== lastPlace) {
        setLastPlace(cityIdentiferPath);
        try {
          await dispatch(fetchConfig(cityIdentiferPath));
        } catch (err) {
          await dispatch(setConfigLoadFailed(true));
        }
      }

      setLoadingConfig(false);
    };
    loadConfig();
  }, [location.pathname, dispatch]);

  return (
    <>
      {loadingConfig && (
        <div className="loading-container">
          <IconIndicator />
        </div>
      )}
      {!loadingConfig && (
        <>
          {!settings?.under_maintenance && <AppRoutes />}
          {settings?.under_maintenance && <MaintainancePage />}
        </>
      )}
    </>
  );
};

export default App;
